<template>
  <Modal
    size="medium"
    close-on-click-outside
    active
    class="add-user-modal"
    @onClose="onClose()">
    <template #header>
      <div class="approver-modal-wrapper-header">
        <div class="approver-modal-header">
          <h2>
            {{ header }}
            <span v-if="editData.userName" class="approver-name">{{
              editData.userName
            }}</span>
          </h2>
          <div class="close-btn" @click="onClose()">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="inherit"
              stroke="inherit"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M15 15L1 1M1 15L15 1L1 15Z"
                stroke="inherit"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
          </div>
        </div>
      </div>
    </template>
    <div slot="content">
      <div class="body">
        <div class="add-user-form">
          <section class="basic-details">
            <h4 class="title">Basic Details</h4>
            <div class="content">
              <div>
                <div class="label">
                  User
                  <span class="am-required">*</span>
                </div>
                <user-control
                  placeholder="Choose User"
                  :has-error="!!error.userApmId"
                  :value="editData.userName"
                  :disabled="editMode"
                  @input="userChange">
                </user-control>
              </div>
              <div>
                <div class="label">
                  L1 Manager
                  <span class="am-required">*</span>
                </div>
                <user-control
                  placeholder="Choose L1 Manager"
                  :has-error="!!error.l1ApmId"
                  :value="editData.l1ApmId"
                  @input="l1ManagerChange"></user-control>
              </div>
              <div>
                <div class="label">
                  L2 Manager
                  <span class="am-required">*</span>
                </div>
                <user-control
                  placeholder="Choose L2 Manager"
                  :has-error="!!error.l2ApmId"
                  :value="editData.l2ApmId"
                  @input="l2ManagerChange"></user-control>
              </div>
              <div>
                <div class="label">
                  Site Leader
                  <span class="am-required">*</span>
                </div>
                <user-control
                  placeholder="Choose Site Leader"
                  :has-error="!!error.siteLeaderApmId"
                  :value="editData.siteLeaderApmId"
                  @input="siteManagerChange">
                </user-control>
              </div>
              <div>
                <Dropdown
                  :options="lobList"
                  label="Select Line Of Business"
                  placeholder="Select Line Of Business"
                  optional-label=""
                  filter-name=""
                  dropdown-label="label"
                  error-message=""
                  help-message=""
                  help-message-position="left"
                  :value="lobDropdownValue"
                  :clearable="false"
                  :loading="false"
                  :filterable="true"
                  :close-on-select="true"
                  :multiple="false"
                  :disabled="false"
                  :hover="false"
                  :error="false"
                  disabled-option="Select"
                  @onChange="
                    onDropdownChange($event, userProfileDropdowns.lob)
                  " />
              </div>
              <div>
                <Dropdown
                  :options="carrierCodeList"
                  label="Carrier Code"
                  placeholder="Select Carrier Code"
                  optional-label=""
                  filter-name=""
                  dropdown-label="label"
                  error-message=""
                  help-message=""
                  help-message-position="left"
                  :value="carrierCodeValue"
                  :clearable="false"
                  :loading="false"
                  :filterable="false"
                  :close-on-select="true"
                  :multiple="true"
                  :disabled="false"
                  :hover="false"
                  :error="false"
                  disabled-option="Select"
                  @onChange="
                    onDropdownChange($event, userProfileDropdowns.carrierCode)
                  " />
              </div>
              <div>
                <Dropdown
                  :options="countryList"
                  label="Country Code"
                  placeholder="Select Country Code"
                  optional-label=""
                  filter-name=""
                  dropdown-label="label"
                  error-message=""
                  help-message=""
                  help-message-position="left"
                  :value="countryCodeValue"
                  :clearable="false"
                  :loading="false"
                  :filterable="true"
                  :close-on-select="true"
                  :multiple="true"
                  :disabled="false"
                  :hover="false"
                  :error="false"
                  disabled-option="Select"
                  @onChange="
                    onDropdownChange($event, userProfileDropdowns.countryCode)
                  " />
              </div>
              <div>
                <Dropdown
                  :options="tenderApplicableList"
                  label="Select Tender Applicable"
                  placeholder="Select Tender Applicable"
                  optional-label=""
                  filter-name=""
                  dropdown-label="label"
                  error-message=""
                  help-message=""
                  help-message-position="left"
                  :value="tenderApplicableDropdownValue"
                  :clearable="false"
                  :loading="false"
                  :filterable="false"
                  :close-on-select="true"
                  :multiple="false"
                  :disabled="false"
                  :hover="false"
                  :error="false"
                  disabled-option="Select"
                  @onChange="
                    onDropdownChange(
                      $event,
                      userProfileDropdowns.tenderApplicable
                    )
                  " />
              </div>
              <div>
                <Dropdown
                  :options="gscList"
                  label="Select GSC"
                  placeholder="Select GSC"
                  optional-label=""
                  filter-name=""
                  dropdown-label="label"
                  error-message=""
                  help-message=""
                  help-message-position="left"
                  :value="gscDropdownValue"
                  :clearable="false"
                  :loading="false"
                  :filterable="false"
                  :close-on-select="true"
                  :multiple="false"
                  :disabled="false"
                  :hover="false"
                  :error="false"
                  disabled-option="Select"
                  @onChange="
                    onDropdownChange($event, userProfileDropdowns.gsc)
                  " />
              </div>
              <div>
                <Dropdown
                  :options="rolesList"
                  label="Select Role"
                  placeholder="Select Role"
                  optional-label=""
                  filter-name=""
                  dropdown-label="label"
                  error-message=""
                  help-message=""
                  help-message-position="left"
                  :value="rolesDropdownValue"
                  :clearable="false"
                  :loading="false"
                  :filterable="false"
                  :close-on-select="true"
                  :multiple="true"
                  :disabled="false"
                  :hover="false"
                  :error="false"
                  disabled-option="Select"
                  @onChange="
                    onDropdownChange($event, userProfileDropdowns.roles)
                  " />
              </div>
              <div>
                <Dropdown
                  :options="skillsList"
                  label="Select Skill"
                  placeholder="Select Skill"
                  optional-label=""
                  filter-name=""
                  dropdown-label="label"
                  error-message=""
                  help-message=""
                  help-message-position="left"
                  :value="skillsDropdownValue"
                  :clearable="false"
                  :loading="false"
                  :filterable="false"
                  :close-on-select="true"
                  :multiple="true"
                  :disabled="false"
                  :hover="false"
                  :error="false"
                  disabled-option="Select"
                  @onChange="
                    onDropdownChange($event, userProfileDropdowns.skills)
                  " />
              </div>
            </div>
          </section>
        </div>
      </div>
      <div class="footer">
        <div>
          <Button :label="submitBtnText" @onClick="handleSubmit" />
          <custom-button-v2
            v-if="processing"
            label="processing..."
            :disabled="processing"></custom-button-v2>
        </div>
      </div>
    </div>
  </Modal>
</template>
<script>
import { CustomButtonV2 } from "@/components/common";
import { isEmpty, getMsalIdToken } from "@/utils/helpers";
import UserControl from "./UserControl";
import { userProfileDropdowns } from "@/config/userProfileConst.js";
// Actions
import { userActions } from "@/actions";

import AxiosFetch from "@/utils/axios";

export default {
  name: "ApproverModal",
  components: {
    CustomButtonV2,
    UserControl,
  },
  props: {
    // isOpen: { type: Boolean, required: true },
    editData: {
      type: Object,
      default: () => {
        return {};
      },
    },
    header: { type: String, default: "" },
    submitBtnText: { type: String, default: "" },
    name: { type: String, default: "" },
  },
  data: () => {
    return {
      userProfileDropdowns,
      editMode: false,
      gscList: [
        {
          value: "BOM",
          label: "BOM",
        },
        {
          value: "CGD",
          label: "CGD",
        },
        {
          value: "MAA",
          label: "MAA",
        },
        {
          value: "MNL",
          label: "MNL",
        },
        {
          value: "Not Migrated",
          label: "Not Migrated",
        },
        {
          value: "ALL",
          label: "ALL",
        },
      ],
      tenderApplicableList: [
        {
          value: "true",
          label: "true",
        },
        {
          value: "false",
          label: "false",
        },
        {
          value: "ALL",
          label: "ALL",
        },
      ],
      lobList: [
        {
          value: "Ocean",
          label: "Ocean",
        },
        {
          value: "LNS",
          label: "LNS",
        },
      ],
      rolesList: [
        {
          value: "Amendment",
          label: "Amendment",
        },
        {
          value: "Endorser",
          label: "Endorser",
        },
        {
          value: "Leader",
          label: "Leader",
        },
        {
          value: "Reporting team",
          label: "Reporting team",
        },
        {
          value: "Indexer",
          label: "Indexer",
        },
        {
          value: "Resolver",
          label: "Resolver",
        },
        {
          value: "ALL",
          label: "ALL",
        },
      ],
      skillsList: [
        {
          value: "Import DnD",
          label: "Import DnD",
        },
        {
          value: "Export DnD",
          label: "Export DnD",
        },
        {
          value: "FREIGHT",
          label: "FREIGHT",
        },
        {
          value: "ALL",
          label: "ALL",
        },
      ],
      userRequest: {},
      countryList: [],
      carrierCodeList: [],
      selectedCountry: null,
      error: {},
      requiredFields: {
        basic: ["userApmId", "l1ApmId", "l2ApmId", "siteLeaderApmId", "gsc"],
      },
      processing: false,
      shouldValidate: false,
      operatorName: [],
      validationError: false,
      duplicateApproverLimits: false,
      duplicateEndorserLimits: false,
      endorserCountryList: [],
      gscDropdownValue: [],
      rolesDropdownValue: [],
      skillsDropdownValue: [],
      lobDropdownValue: [],
      tenderApplicableDropdownValue: [],
      countryCodeValue: [],
      carrierCodeValue: [],
    };
  },
  computed: {
    user() {
      return this.$store.getters.getUserData;
    },
  },
  watch: {
    isOpen() {
      this.processing = false;
    },
    editData() {
      this.userRequest = { ...this.editData };
      const {
        lineOfBusiness,
        tenderApplicable,
        gsc,
        roles,
        skills,
        assignedCountryCode,
        assignedCarrierCode,
      } = this.editData;
      this.lobDropdownValue = [
        { value: lineOfBusiness, label: lineOfBusiness },
      ];
      this.gscDropdownValue = [{ value: gsc, label: gsc }];
      this.tenderApplicableDropdownValue = tenderApplicable.map((item) => {
        return {
          value: item,
          label: item,
        };
      });

      this.rolesDropdownValue = roles.map((item) => {
        return {
          value: item,
          label: item,
        };
      });
      this.countryCodeValue = assignedCountryCode.map((item) => {
        return {
          value: item,
          label: item,
        };
      });
      this.carrierCodeValue = assignedCarrierCode.map((item) => {
        return {
          value: item,
          label: item,
        };
      });
      this.skillsDropdownValue = skills.map((item) => {
        return {
          value: item,
          label: item,
        };
      });
      if (!isEmpty(this.editData)) {
        this.editMode = true;
      }
    },
  },
  mounted: function () {
    this.getCountryCodeDetails();
    this.getCarrierDetails();
    this.userRequest = { ...this.editData };
    console.log("editData: ", this.editData?.userApmId);
    const {
      lineOfBusiness,
      tenderApplicable,
      gsc,
      roles,
      skills,
      assignedCountryCode,
      assignedCarrierCode,
    } = this.editData;
    this.lobDropdownValue = lineOfBusiness;
    this.gscDropdownValue = gsc;
    this.tenderApplicableDropdownValue = tenderApplicable.map((item) => {
      return {
        value: item,
        label: item,
      };
    });
    this.rolesDropdownValue = roles.map((item) => {
      return {
        value: item,
        label: item,
      };
    });
    this.countryCodeValue = assignedCountryCode.map((item) => {
      return {
        value: item,
        label: item,
      };
    });
    this.carrierCodeValue = assignedCarrierCode.map((item) => {
      return {
        value: item,
        label: item,
      };
    });
    this.skillsDropdownValue = skills.map((item) => {
      return {
        value: item,
        label: item,
      };
    });
  },
  methods: {
    beforeModalOpen() {
      this.userRequest = {};
      this.processing = false;
      this.error = {};
      this.validationError = false;
    },

    async getCountryCodeDetails() {
      const payload = await userActions.getCountryDetails(
        `Bearer ${await getMsalIdToken(this)}`
      );
      try {
        const response = await AxiosFetch(payload);
        this.countryList = response.data
          .map((country) => ({
            label: `${country.countryName}`,
            value: country.countryCode,
          }))
          .sort((a, b) => a.label.localeCompare(b.label));
      } catch (err) {
        console.error(err);
      }
    },
    async getCarrierDetails() {
      const payload = await userActions.getCarrierCodeDetails(
        `Bearer ${await getMsalIdToken(this)}`
      );
      try {
        const carrierResponse = await AxiosFetch(payload);
        this.carrierCodeList = carrierResponse.data.map((carrier) => ({
          label: `${carrier.brandCode}: ${carrier.operator}`,
          value: carrier.brandCode,
        }));
      } catch (err) {
        console.error(err);
      }
    },
    onClose() {
      this.shouldValidate = false;
      this.processing = false;
      this.error = {};
      this.validationError = false;
      this.editMode = false;
      this.$emit("onModalClose");
    },
    resetProcessButton() {
      this.processing = false;
    },
    validate() {
      let error = {};
      this.validationError = false;
      if (!this.shouldValidate) {
        return error;
      }
      this.requiredFields.basic.forEach((key) => {
        const value = this.userRequest[key];
        console.log("value:::::::::", value);
        if (!value || isEmpty(value)) {
          error[key] = "Required";
        }
      });
      this.error = { ...error };
      if (!isEmpty(this.error)) {
        this.validationError = true;
      }
      return error;
    },
    handleSubmit() {
      console.log("userRequest", JSON.stringify(this.userRequest));
      this.processing = false;
      this.shouldValidate = true;
      let updatedUserRequest = { ...this.userRequest };
      console.log(
        "Updated Approver Request:",
        JSON.stringify(updatedUserRequest)
      );
      const error = this.validate();
      if (isEmpty(error)) {
        this.validationError = false;
        this.processing = true;
        this.$emit("onSubmit", updatedUserRequest);
      }
    },
    userChange(val) {
      const { displayName, employeeId, id, mail } = val;
      this.userRequest = {
        ...this.userRequest,
        userApmId: employeeId,
        userName: displayName,
        userEmail: mail,
      };
      this.validate();
    },
    l1ManagerChange(val) {
      const { displayName, employeeId, id, mail } = val;
      this.userRequest = {
        ...this.userRequest,
        l1ApmId: employeeId,
      };
      this.validate();
    },
    l2ManagerChange(val) {
      const { displayName, employeeId, id, mail } = val;
      this.userRequest = {
        ...this.userRequest,
        l2ApmId: employeeId,
      };
      this.validate();
    },
    siteManagerChange(val) {
      const { displayName, employeeId, id, mail } = val;
      this.userRequest = {
        ...this.userRequest,
        siteLeaderApmId: employeeId,
      };
      this.validate();
    },
    onDropdownChange(elt, dropdownType) {
      this.isFilterApplied = true;
      if (dropdownType == userProfileDropdowns.gsc) {
        this.gscDropdownValue = elt?.value;
        this.userRequest = {
          ...this.userRequest,
          gsc: elt?.value.value,
        };
      } else if (dropdownType == userProfileDropdowns.roles) {
        this.rolesDropdownValue = elt?.value;
        this.userRequest.roles = [
          ...new Set(
            (Array.isArray(elt?.value) ? elt?.value : [elt?.value])
              .map((item) => item?.value)
              .filter(Boolean)
          ),
        ];
      } else if (dropdownType == userProfileDropdowns.skills) {
        this.skillsDropdownValue = elt?.value;
        this.userRequest.skills = [
          ...new Set(
            (Array.isArray(elt?.value) ? elt?.value : [elt?.value])
              .map((item) => item?.value)
              .filter(Boolean)
          ),
        ];
      } else if (dropdownType == userProfileDropdowns.lob) {
        this.lobDropdownValue = elt?.value;
        this.userRequest = {
          ...this.userRequest,
          lineOfBusiness: elt?.value.value,
        };
      } else if (dropdownType == userProfileDropdowns.tenderApplicable) {
        this.tenderApplicableDropdownValue = elt?.value;
        this.userRequest = {
          ...this.userRequest,
          tenderApplicable: [elt?.value.value].filter(Boolean),
        };
      } else if (dropdownType == userProfileDropdowns.carrierCode) {
        this.carrierCodeValue = elt?.value;
        this.userRequest.assignedCarrierCode = [
          ...new Set(
            (Array.isArray(elt?.value) ? elt?.value : [elt?.value])
              .map((item) => item?.value)
              .filter(Boolean)
          ),
        ];
      } else if (dropdownType == userProfileDropdowns.countryCode) {
        this.countryCodeValue = elt?.value;
        this.userRequest.assignedCountryCode = [
          ...new Set(
            (Array.isArray(elt?.value) ? elt?.value : [elt?.value])
              .map((item) => item?.value)
              .filter(Boolean)
          ),
        ];
      }
    },
  },
};
</script>

<style lang="scss" scoped>
// Styles Imports
@import "@/styles/imports";

.add-user-modal {
  &:focus {
    outline: none;
  }

  .approver-modal-wrapper {
    width: 900px;
    background-color: #ededed;
    padding: 24px;

    .approver-modal-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 75px;

      .close-btn {
        cursor: pointer;

        svg {
          stroke: #0073ab;
        }
      }

      h2 {
        color: #0073ab;
        font-family: "Maersk Headline Bold";
        font-size: 24px;

        @include media("<740px") {
          max-width: 230px;
          font-size: 1rem;
          display: block;
          background: red($color: #000000);
        }

        .approver-name {
          color: var(--primary-text);
          font-weight: normal;
        }
      }
    }

    .body {
      overflow-y: auto;
      max-height: 670px;
      max-width: 100vh;

      @include media("<=1024px") {
        min-width: 75vw;
      }

      @include media("<=724px") {
        width: 80vw;
      }

      & .add-user-form {
        section {
          background-color: #ffffff;
          padding: 1rem;
          display: flex;
          flex-direction: column;
          margin-bottom: 1rem;

          .content {
            display: flex;
            flex-wrap: wrap;

            > div {
              flex-basis: 33.33%;
              padding-right: 1.5rem;
              margin-bottom: 1rem;
              box-sizing: border-box;

              &:nth-child(3),
              &:nth-child(6),
              &:nth-child(9) {
                padding: 0;

                @include media("<=1024px") {
                  padding-right: 1.5rem;
                }
              }
            }

            @include media("<=1024px") {
              flex-direction: column;
            }
          }

          .title {
            flex: 1;
            margin-top: 0;
          }
        }
      }
    }
  }
}

.am-required {
  color: red;
}

.required-modal {
  color: red;
  font-size: 0.875rem;
}

.footer {
  display: flex;
  justify-content: space-between;
  padding: 1rem 0 0 0;
}

.view-history-btn-container {
  flex: 1;
}

.radio-control {
  margin-top: 0.375rem;
}
</style>
<style lang="scss">
@import "@/styles/imports";

.view-history-btn {
  .btn-label {
    border-bottom: 1px solid;
  }
}

.label {
  font-family: "Maersk Text";
  font-size: 1rem;
  color: #000000;
  margin-bottom: 0.3125rem;
  display: inline-block;
}

.vm--modal {
  background: transparent !important;
  box-shadow: none !important;
}

.vm--container {
  z-index: 9999 !important;
}

.add-user-modal {
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;

  @include media("<=1024px") {
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
  }

  .textinput {
    .label {
      font-family: "Maersk Headline";
      font-size: 1rem;
      color: var(--primary-text);
      text-transform: none;
    }

    textarea {
      border: 1px solid var(--card-border);
    }

    input {
      min-height: 35px;
      padding-top: 0;
      padding-bottom: 0;
      font-family: "Maersk Headline";
    }
  }
}

.add-user-form {
  .title {
    font-family: "Maersk Headline";
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 24px;
    color: #000000;
  }
}

.approver-name-readonly {
  background: #f7f7f7;
  border: 1px solid #cfcfcf;
  border-radius: 0.25rem;
  font-family: "Maersk Headline";
  font-size: 0.875rem;
  min-height: 35px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 0 0.3125rem;
  color: #000000;

  strong {
    margin-right: 0.25rem;
    font-family: "Maersk Headline";
    font-size: 14px;
  }
}
</style>
